import _ from 'lodash'
import ApiTagManager from '@/helpers/ApiTagManager'

/** VUEX module for tags in Tag Generator section **/

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    adserver_id: null,
    adservers: null,
    campaign: null,
    creatives: [],
    placements: [],
    tags: null,
    templates: null,
    tag_version_id: 1, // default Version 1
    tag_versions: null,
    creative_sizes: [
      { id: 1, name: '970x90', value: '970x90' },
      { id: 2, name: '728x90', value: '728x90' },
      { id: 3, name: '300x250', value: '300x250' },
      { id: 4, name: '320x50', value: '320x50' }
    ],
    creative_size_selected: [],
    creative_size_checked: false,
    adserverSize: [
      { id: 1, name: 'Advangelists', tagwidth: '{AD_WIDTH}', tagheight: '{AD_HEIGHT}' },
      { id: 2, name: 'Xandr', tagwidth: '\${WIDTH}', tagheight: '\${HEIGHT}' },
      { id: 3, name: 'DoubleClick Bid Manager (DV360)', tagwidth: '\${WIDTH}', tagheight: '\${HEIGHT}' },
      { id: 4, name: 'DoubleClick Campaign Manager (DCM)', tagwidthnheight: '%p;sz=!;' },
      { id: 5, name: 'DoubleClick For Publishers (DFP)', tagwidthnheight: '%p;sz=!;' },
      { id: 6, name: 'Yahoo', tagwidth: '\${WIDTH}', tagheight: '\${HEIGHT}' },
      { id: 7, name: 'The Trade Desk', tagwidthnheight: '%%TTD_ADFORMAT%%' },
      { id: 8, name: 'Amobee', tagwidth: '$!{WIDTH}', tagheight: '$!{HEIGHT}' },
      { id: 9, name: 'MediaMath', tagwidth: '[AD_ATTR.width]', tagheight: '[AD_ATTR.height]' },
      { id: 10, name: 'Adobe (TubeMogul)', tagwidth: '\${WIDTH}', tagheight: '\${HEIGHT}' },
      { id: 11, name: 'Cannavu', tagwidthnheight: '{dimensions}' },
      { id: 12, name: 'Adelphic', tagwidth: '\${WIDTH}', tagheight: '\${HEIGHT}' },
      { id: 13, name: 'Basis', tagwidthnheight: '{dimensions}' },
      { id: 14, name: 'DeepIntent DSP', tagwidth: '\${WIDTH}', tagheight: '\${HEIGHT}' },
      { id: 15, name: 'Stack Adapt', tagwidth: '{SA_WIDTH}', tagheight: '{SA_HEIGHT}' },
      { id: 16, name: 'Beeswax DSP', tagwidth: '{{WIDTH}}', tagheight: '{{HEIGHT}}' }
    ],
    tag_version_script: [
      { id: 1, name: 'Celtra (Simpli Tag v1)', value:
        `<img style='display:none' src="data:image/png,pdsqdx" onerror="(function(img) {
          var scrpt=document.createElement('script');
          scrpt.src='{{JSFileURL}}';
          img.parentNode.insertBefore(scrpt, img.nextSibling);
        })(this)" />` },
      { id: 2, name: 'Airtory (Simpli Tag v2)', value:
        `<img style='display:none' src="data:image/png,pdsqdx" onerror="(function(img) {
          var scrpt=document.createElement('script');
          scrpt.src='{{JSFileURLV2}}';
          img.parentNode.insertBefore(scrpt, img.nextSibling);
      })(this)" />` },
      { id: 3, name: 'PadSquad (Simpli Tag V3)', value:
      `<img style='display:none' src="data:image/png,pdsqdx" onerror="(function(img) {
          const scrpt = document.createElement('script');
          scrpt.src = '{{JSFileURLV3}}';
          scrpt.type = 'module';
          scrpt.defer = true;
          img.parentNode.insertBefore(scrpt, img.nextSibling);
        })(this)" />` }
    ]
  },
  // -----------------------------------------------------------------
  getters: {
    getTagsByAdServer: (state, getters) => id => {
      const item = state.tags.find(item => item.adserver.id == id)
      return item.placements_tags
    },
    campaign: (state, getters) => {
      return state.campaign
    },
    creativeIdByPlacementId: (state, getters) => placementId => {
      const creative = state.creatives.find(x => x.placementId.toString() === placementId.toString())

      return creative ? creative.id : ''
    },
    placements: (state, getters, rootState, rootGetters) => {
      /* let item = state.tags.find(item => item.adserver.id == id);
      return item.placements_tags; */

      /**
       * a function to replace macros/keywords from a string template.
       * @param {String} template
       * @param {Object} replaceMacros - Object containing macros and it's values
       */
      const buildTemplate = function (template, replaceMacros) {
        let newTemplate = template

        // iterate over the keys of the replaceMacros objects
        Object.keys(replaceMacros).map((macroName) => {
          // get the macro value
          const macroValue = replaceMacros[macroName]

          // replace the macro with the value
          newTemplate = newTemplate.replaceAll(`{{${macroName}}}`, macroValue)
        })

        return newTemplate
      }

      // get placements
      const placements = state.placements
      if (state.adserver_id > 0) {
        // pick the right adserver_template
        const adserver = _.find(state.adservers, {
          id: state.adserver_id
        })

        // generate a template for each tag and store them in the tags var on this format tags[placement_id] = generated_tag
        placements.map((placement, i) => {
          // let advertiser = rootGetters['advertisers/list'][getters.campaign.advertiser_id] || {};
          // advertiser = advertiser.name || "";

          // get the right template from the adserver and add the width and height
          let getWidth = 'WIDTH'; let getHeight = 'HEIGHT'; let getWidthHeight = 'WIDTHxHEIGHT'; let oneTag = false
          if (state.adserver_id > 0) {
            // check if state.adserver_id is differente than 4,5,6 and 8
            if (state.adserver_id == 4 || state.adserver_id == 5 || state.adserver_id == 7 || state.adserver_id == 11 || state.adserver_id == 13) {
              getWidthHeight = state.adserverSize.find(item => item.id == state.adserver_id).tagwidthnheight; oneTag = true
            } else {
              getWidth = state.adserverSize.find(item => item.id == state.adserver_id).tagwidth
              getHeight = state.adserverSize.find(item => item.id == state.adserver_id).tagheight
            }
          }
          if (state.creative_size_selected[i]?.selected) {
            // console.log('testt for state', state.creative_size_selected[i].selected);
            if (state.creative_size_selected[i].selected !== 'Select a size:') {
              oneTag ? getWidthHeight = state.creative_size_selected[i].selected : getWidth = state.creative_size_selected[i].selected.split('x')[0]; getHeight = state.creative_size_selected[i].selected.split('x')[1]
              // console.log('los macros', state.creative_size_selected[i].selected !== 'Select a size:' ? 'TRUE' : 'FALSE');
            } else {
              oneTag ? getWidthHeight = getWidthHeight : getWidth = getWidth; getHeight = getHeight
            }
          }

          // macros we want to replace in our template
          const macros = {
            TagName: `${placement.id}_${placement.name}`,
            Advertiser: getters.campaign.advertiser,
            CampaignName: getters.campaign.name,
            PlacementName: placement.name,
            Format: placement.format,
            FallBackImage: getters.campaign.id,
            // "FallBackUrl": getters.campaign.campaign_url,
            FallBackUrl: placement.use_fallback_clicktrough_url ? placement.fallback_clicktrough_url : getters.campaign.campaign_url,
            getWidth,
            getHeight,
            getWidthHeight,
            simpliTagScript: getters.simpliTagScript,
            ps_tag_id: getters.ps_tag_id,
            isOverwrite: state.creative_size_checked,
            DEAL_ID: '',
            '3P_ID': placement.third_party_id,
            CampaignID: getters.campaign.id,
            PlacementID: placement.id,
            CreativeID: getters.creativeIdByPlacementId(placement.id),
            ExternalCreativeID: placement.external_creative_id,
            FormatID: placement.format_id,
            JSFileURL: `${process.env.VUE_APP_SIMPLI_TAG_SCRIPT_PATH}`,
            JSFileURLV2: `${process.env.VUE_APP_SIMPLI_TAG_SCRIPT_PATH_VERSION_2}${getters.campaign.id}/${placement.id}`,
            JSFileURLV3: `${process.env.VUE_APP_SIMPLI_TAG_SCRIPT_PATH_VERSION_3}${getters.campaign.id}/${placement.id}?v=3`
          }

          placement.tag = (state.tag_version_id === 1) ? buildTemplate(adserver.simpli_tag_template, macros) : buildTemplate(adserver.simpli_tag_template_v2, macros)
          placement.tagcsv = (state.tag_version_id === 1) ? buildTemplate(adserver.simpli_tag_template_min, macros) : buildTemplate(adserver.simpli_tag_template_v2_min, macros)
        })
      }

      return placements
    },
    adservers: (state, getters) => {
      return state.adservers
    },
    simpliTagScript: (state, getters) => {
      const tagScript = state.tag_version_script.find(script => script.id === state.tag_version_id)
      return tagScript ? tagScript.value : ''
    },
    creative_sizes: (state, getters) => {
      return state.creative_sizes
    },
    creative_size_selected: (state, getters) => {
      return state.creative_size_selected
    },
    creative_size_checked: (state) => {
      return state.creative_size_checked
    },
    ps_tag_id: (state) => {
      return state.tag_version_id === 3 ? ' id="ps_placement_{{CampaignID}}_{{PlacementID}}"' : ''
    },
    templates: (state, getters) => {
      return state.templates
    },
    tag_versions: state => state.tag_versions
  },
  // -----------------------------------------------------------------
  mutations: {
    SET: (state, payload) => {
      state.campaign = payload.campaign
      state.tags = payload.tags
      state.templates = payload.templates
      state.placements = payload.placements

      state.tag_versions = [{
          id: 1,
          name: 'Celtra (Simpli Tag v1)'
        },
        {
          id: 2,
          name: 'Airtory (Simpli Tag v2)'
        },
        {
          id: 3,
          name: 'PadSquad (Simpli Tag V3)'
        }
      ]

      state.adservers = [{
        name: 'Advangelists',
        id: 1,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Advangelists -->
    <!-- eCreativeId            = {BANNER_ID} -->
    <!-- eCampaignId            = {CAMPAIGN_ID} -->
    <!-- eSiteId                = {APP_ID} -->
    <!-- eSiteName              = {APP_NAME} -->
    <!-- eBundleId              = {APP_BUNDLE} -->
    <!-- ePublisherId           = {PUB_ID} -->
    <!-- eAuctionId             = {AUCTION_ID} -->
    <!-- eGPSLat                = {LATTITUDE} -->
    <!-- eGPSLng                = {LONGITUDE} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->
    <!-- eIFAIOS                = {DEVICE_IFA} -->
    <!-- eIFAAndroid            = {DEVICE_IFA} -->
    <!-- eClickURL              = {clickurl} -->
    <!-- eTagId                 = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Advangelists -->
    <!-- eCreativeId            = {BANNER_ID} -->
    <!-- eCampaignId            = {CAMPAIGN_ID} -->
    <!-- eSiteId                = {APP_ID} -->
    <!-- eSiteName              = {APP_NAME} -->
    <!-- eBundleId              = {APP_BUNDLE} -->
    <!-- ePublisherId           = {PUB_ID} -->
    <!-- eAuctionId             = {AUCTION_ID} -->
    <!-- eGPSLat                = {LATTITUDE} -->
    <!-- eGPSLng                = {LONGITUDE} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->
    <!-- eIFAIOS                = {DEVICE_IFA} -->
    <!-- eIFAAndroid            = {DEVICE_IFA} -->
    <!-- eClickURL              = {clickurl} -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer  = Advangelists --><!-- eCreativeId = {BANNER_ID} --><!-- eTagId = \${TAG_ID} --><!-- eCampaignId  = {CAMPAIGN_ID} --><!-- eSiteId = {APP_ID} --><!-- eSiteName = {APP_NAME} --><!-- eBundleId = {APP_BUNDLE} --><!-- ePublisherId = {PUB_ID} --><!-- eAuctionId = {AUCTION_ID} --><!-- eGPSLat = {LATTITUDE} --><!-- eGPSLng = {LONGITUDE} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- eIFAIOS = {DEVICE_IFA} --><!-- eIFAAndroid = {DEVICE_IFA} --><!-- eClickURL = {clickurl} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement  = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL = {{FallBackUrl}} --><!-- pdsqdx3PID   = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} --><img style=\'display:none\' src="data:image/png,pdsqdx" onerror="(function(img) { var scrpt=document.createElement(\'script\'); scrpt.src=\'{{JSFileURL}}\'; img.parentNode.insertBefore(scrpt, img.nextSibling);})(this)" /></div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Advangelists --><!-- eCreativeId = {BANNER_ID} --><!-- eTagId = \${TAG_ID} --><!-- eCampaignId = {CAMPAIGN_ID} --><!-- eSiteId = {APP_ID} --><!-- eSiteName = {APP_NAME} --><!-- eBundleId = {APP_BUNDLE} --><!-- ePublisherId = {PUB_ID} --><!-- eAuctionId  = {AUCTION_ID} --><!-- eGPSLat = {LATTITUDE} --><!-- eGPSLng  = {LONGITUDE} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- eIFAIOS = {DEVICE_IFA} --><!-- eIFAAndroid= {DEVICE_IFA} --><!-- eClickURL = {clickurl} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Xandr',
        id: 2,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = AppNexus -->
    <!-- eCreativeId            = \${CREATIVE_ID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- ePlacementId           = \${DEAL_ID} -->
    <!-- eCampaignId            = \${CP_ID} -->
    <!-- eSiteName              = \${REFERER_URL_ENC} -->
    <!-- ePublisherId           = \${PUBLISHER_ID} -->
    <!-- eAdvertiserId          = \${PUBLISHER_ID} -->
    <!-- eAuctionId             = \${AUCTION_ID} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight} -->
    <!-- eIFAIOS                = \${DEVICE_APPLE_IDA} -->
    <!-- eIFAAndroid            = \${DEVICE_AAID} -->
    <!-- eClickURL              = \${CLICK_URL} -->
    <!-- eXandrPlacementId      = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID     = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = AppNexus -->
    <!-- eCreativeId            = \${CREATIVE_ID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- ePlacementId           = \${DEAL_ID} -->
    <!-- eCampaignId            = \${CP_ID} -->
    <!-- eSiteName              = \${REFERER_URL_ENC} -->
    <!-- ePublisherId           = \${PUBLISHER_ID} -->
    <!-- eAdvertiserId          = \${PUBLISHER_ID} -->
    <!-- eAuctionId             = \${AUCTION_ID} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->
    <!-- eIFAIOS                = \${DEVICE_APPLE_IDA} -->
    <!-- eIFAAndroid            = \${DEVICE_AAID} -->
    <!-- eClickURL              = \${CLICK_URL} -->
    <!-- eXandrPlacementId      = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = AppNexus --><!-- eCreativeId = ${CREATIVE_ID} --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId = ${DEAL_ID} --><!-- eCampaignId = ${CP_ID} --><!-- eSiteName = ${REFERER_URL_ENC} -->    <!-- ePublisherId = ${PUBLISHER_ID} -->    <!-- eAdvertiserId = ${PUBLISHER_ID} --><!-- eAuctionId = ${AUCTION_ID} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- eIFAIOS = ${DEVICE_APPLE_IDA} --><!-- eIFAAndroid  = ${DEVICE_AAID} --><!-- eClickURL  = ${CLICK_URL} --><!-- eXandrPlacementId = \${TAG_ID} -->{{simpliTagScript}}</div>',
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer  = AppNexus --><!-- eCreativeId  = ${CREATIVE_ID} --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId  = ${DEAL_ID} --><!-- eCampaignId  = ${CP_ID} --><!-- eSiteName  = ${REFERER_URL_ENC} --><!-- ePublisherId  = ${PUBLISHER_ID} --><!-- eAdvertiserId  = ${PUBLISHER_ID} --><!-- eAuctionId  = ${AUCTION_ID} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- eIFAIOS  = ${DEVICE_APPLE_IDA} --><!-- eIFAAndroid  = ${DEVICE_AAID} --><!-- eClickURL  = ${CLICK_URL} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement  = {{PlacementName}} --><!-- pdsqdxFormat  = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --> <!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} --><!-- eXandrPlacementId = \${TAG_ID} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'DoubleClick Bid Manager (DV360)',
        id: 3,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DBM -->
    <!-- eCreativeId            = \${CREATIVE_ID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- eSiteId                = \${UNIVERSAL_SITE_ID} -->
    <!-- eSiteName              = \${SOURCE_URL_ENC} -->
    <!-- ePublisherId           = \${PUBLISHER_ID} -->
    <!-- eAdvertiserId          = \${INVENTORY_SOURCE_EXTERNAL_ID} -->
    <!-- eCampaignId            = \${INSERTION_ORDER_ID} -->
    <!-- ePlacementId           = \${CAMPAIGN_ID} -->
    <!-- eAuctionId             = \${AUCTION_ID} -->
    <!-- eDBMExchangeId         = \${EXCHANGE_ID} -->
    <!-- eDBMPixelIdComma       = \${PIXEL_ID_COMMA} -->
    <!-- eClickURL              = \${CLICK_URL} -->
    <!-- eDcDBMToken            = \${DC_DBM_TOKEN} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DBM -->
    <!-- eCreativeId            = \${CREATIVE_ID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- eSiteId                = \${UNIVERSAL_SITE_ID} -->
    <!-- eSiteName              = \${SOURCE_URL_ENC} -->
    <!-- ePublisherId           = \${PUBLISHER_ID} -->
    <!-- eAdvertiserId          = \${INVENTORY_SOURCE_EXTERNAL_ID} -->
    <!-- eCampaignId            = \${INSERTION_ORDER_ID} -->
    <!-- ePlacementId           = \${CAMPAIGN_ID} -->
    <!-- eAuctionId             = \${AUCTION_ID} -->
    <!-- eDBMExchangeId         = \${EXCHANGE_ID} -->
    <!-- eDBMPixelIdComma       = \${PIXEL_ID_COMMA} -->
    <!-- eClickURL              = \${CLICK_URL} -->
    <!-- eDcDBMToken            = \${DC_DBM_TOKEN} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = DBM --><!-- eCreativeId = ${CREATIVE_ID} --><!-- eTagId = \${TAG_ID} --><!-- eSiteId  = ${UNIVERSAL_SITE_ID} --><!-- eSiteName = ${SOURCE_URL_ENC} --><!-- ePublisherId = ${PUBLISHER_ID} --><!-- eAdvertiserId  = ${INVENTORY_SOURCE_EXTERNAL_ID} --><!-- eCampaignId  = ${INSERTION_ORDER_ID} --><!-- ePlacementId = ${CAMPAIGN_ID} --><!-- eAuctionId  = ${AUCTION_ID} --><!-- eDBMExchangeId = ${EXCHANGE_ID} --><!-- eDBMPixelIdComma = ${PIXEL_ID_COMMA} --><!-- eClickURL  = ${CLICK_URL} --> <!-- eDcDBMToken = ${DC_DBM_TOKEN} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = DBM --><!-- eCreativeId = ${CREATIVE_ID} --><!-- eTagId = \${TAG_ID} --><!-- eSiteId = ${UNIVERSAL_SITE_ID} --><!-- eSiteName = ${SOURCE_URL_ENC} --><!-- ePublisherId  = ${PUBLISHER_ID} --><!-- eAdvertiserId = ${INVENTORY_SOURCE_EXTERNAL_ID} --><!-- eCampaignId = ${INSERTION_ORDER_ID} --><!-- ePlacementId = ${CAMPAIGN_ID} --><!-- eAuctionId = ${AUCTION_ID} --><!-- eDBMExchangeId = ${EXCHANGE_ID} --><!-- eDBMPixelIdComma = ${PIXEL_ID_COMMA} --><!-- eClickURL = ${CLICK_URL} --> <!-- eDcDBMToken = ${DC_DBM_TOKEN} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'DoubleClick Campaign Manager (DCM)',
        id: 4,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DCM -->
    <!-- eCreativeId            = %ecid! -->
    <!-- ePlacementId           = %epid! -->
    <!-- eCampaignId            = %ebuy! -->
    <!-- eSiteId                = %esid! -->
    <!-- ePublisherId           = %esid! -->
    <!-- eLineItemId            = %eaid! -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eUserId                = %m -->
    <!-- eClickURL              = %c -->
    <!-- eTagId                 = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DCM -->
    <!-- eCreativeId            = %ecid! -->
    <!-- ePlacementId           = %epid! -->
    <!-- eCampaignId            = %ebuy! -->
    <!-- eSiteId                = %esid! -->
    <!-- ePublisherId           = %esid! -->
    <!-- eLineItemId            = %eaid! -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eUserId                = %m -->
    <!-- eClickURL              = %c -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = DCM --><!-- eCreativeId = %ecid! --><!-- ePlacementId  = %epid! --><!-- eTagId = \${TAG_ID} --><!-- eCampaignId = %ebuy! --><!-- eSiteId = %esid! --><!-- ePublisherId = %esid! --><!-- eLineItemId = %eaid! --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eUserId = %m --><!-- eClickURL  = %c --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID   = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = DCM --><!-- eCreativeId = %ecid! --><!-- ePlacementId = %epid! --><!-- eTagId = \${TAG_ID} --><!-- eCampaignId = %ebuy! --><!-- eSiteId = %esid! --><!-- ePublisherId = %esid! --><!-- eLineItemId = %eaid! --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eUserId = %m --><!-- eClickURL = %c -->{{simpliTagScript}}</div>'
      },
      {
        name: 'DoubleClick For Publishers (DFP)',
        id: 5,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DFPPremium -->
    <!-- eCreativeId            = %ecid! -->
    <!-- ePlacementId           = %epid! -->
    <!-- eCampaignId            = %ebuy! -->
    <!-- eAdvertiserId          = %eadv! -->
    <!-- eSiteId                = %esid! -->
    <!-- ePublisherId           = %esid! -->
    <!-- eSiteName              = %%SITE%% -->
    <!-- eLineItemId            = %eaid! -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eUserId                = %m -->
    <!-- eIFAIOS                = %%ADVERTISING_IDENTIFIER_PLAIN%% -->
    <!-- eIFAAndroid            = %%ADVERTISING_IDENTIFIER_PLAIN%% -->
    <!-- eClickURL              = %%CLICK_URL_UNESC%% -->
    <!-- eTagId                 = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->


    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DFPPremium -->
    <!-- eCreativeId            = %ecid! -->
    <!-- ePlacementId           = %epid! -->
    <!-- eCampaignId            = %ebuy! -->
    <!-- eAdvertiserId          = %eadv! -->
    <!-- eSiteId                = %esid! -->
    <!-- ePublisherId           = %esid! -->
    <!-- eSiteName              = %%SITE%% -->
    <!-- eLineItemId            = %eaid! -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eUserId                = %m -->
    <!-- eIFAIOS                = %%ADVERTISING_IDENTIFIER_PLAIN%% -->
    <!-- eIFAAndroid            = %%ADVERTISING_IDENTIFIER_PLAIN%% -->
    <!-- eClickURL              = %%CLICK_URL_UNESC%% -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = DFPPremium --><!-- eCreativeId = %ecid! --><!-- ePlacementId = %epid! --><!-- eCampaignId = %ebuy! --><!-- eTagId = \${TAG_ID} --><!-- eAdvertiserId = %eadv! --><!-- eSiteId = %esid! --><!-- ePublisherId = %esid! --><!-- eSiteName = %%SITE%% --><!-- eLineItemId = %eaid! --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eUserId = %m --><!-- eIFAIOS = %%ADVERTISING_IDENTIFIER_PLAIN%% --><!-- eIFAAndroid = %%ADVERTISING_IDENTIFIER_PLAIN%% --><!-- eClickURL = %%CLICK_URL_UNESC%% --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID  = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = DFPPremium --><!-- eCreativeId = %ecid! --><!-- ePlacementId = %epid! --><!-- eCampaignId = %ebuy! --><!-- eTagId = \${TAG_ID} --><!-- eAdvertiserId = %eadv! --><!-- eSiteId = %esid! --><!-- ePublisherId = %esid! --><!-- eSiteName = %%SITE%% --><!-- eLineItemId = %eaid! --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eUserId = %m --><!-- eIFAIOS = %%ADVERTISING_IDENTIFIER_PLAIN%% --><!-- eIFAAndroid = %%ADVERTISING_IDENTIFIER_PLAIN%% --><!-- eClickURL = %%CLICK_URL_UNESC%% -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Yahoo',
        id: 6,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Yahoo -->
    <!-- eAdvertiserId          = {ADV_ID} -->
    <!-- eCampaignId            = \${ORDERID} -->
    <!-- eCreativeId            = \${LIBRARYADID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- ePlacementId           = \${PLACEMENTID} -->
    <!-- eSiteName              = \${DOMAIN}  -->
    <!-- eIFAIOS                = \${DEVICE_ID} -->
    <!-- eIFAAndroid            = \${DEVICE_ID} -->
    <!-- eClickURL              = \${CLICKURL} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Yahoo -->
    <!-- eAdvertiserId          = {ADV_ID} -->
    <!-- eCampaignId            = \${ORDERID} -->
    <!-- eCreativeId            = \${LIBRARYADID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- ePlacementId           = \${PLACEMENTID} -->
    <!-- eSiteName              = \${DOMAIN}  -->
    <!-- eIFAIOS                = \${DEVICE_ID} -->
    <!-- eIFAAndroid            = \${DEVICE_ID} -->
    <!-- eClickURL              = \${CLICKURL} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Yahoo --><!-- eAdvertiserId = {ADV_ID} --><!-- eCampaignId = ${ORDERID} --><!-- eCreativeId = ${LIBRARYADID} --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId = ${PLACEMENTID} --><!-- eSiteName = ${DOMAIN}  --><!-- eIFAIOS = ${DEVICE_ID} --><!-- eIFAAndroid = ${DEVICE_ID} --><!-- eClickURL = ${CLICKURL} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Yahoo --><!-- eAdvertiserId = {ADV_ID} --><!-- eCampaignId = ${ORDERID} --><!-- eCreativeId = ${LIBRARYADID} --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId = ${PLACEMENTID} --><!-- eSiteName = ${DOMAIN}  --><!-- eIFAIOS = ${DEVICE_ID} --><!-- eIFAAndroid = ${DEVICE_ID} --><!-- eClickURL = ${CLICKURL} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'The Trade Desk',
        id: 7,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = TradeDesk -->
    <!-- eCreativeId            = %%TTD_CREATIVEID%% -->
    <!-- ePlacementId           = %%TTD_ADGROUPID%% -->
    <!-- eCampaignId            = %%TTD_CAMPAIGNID%% -->
    <!-- eAdvertiserId          = %%TTD_ADVERTISERID%% -->
    <!-- eSiteName              = %%TTD_SITE%% -->
    <!-- ePublisherId           = %%TTD_PARTNERID%% -->
    <!-- ePublisherName         = %%TTD_SUPPLYVENDOR%% -->
    <!-- eGPSLat                = %%TTD_LAT%% -->
    <!-- eGPSLng                = %%TTD_LONG%% -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eIFAIOS                = %%TTD_DEVICEID%% -->
    <!-- eIFAAndroid            = %%TTD_DEVICEID%% -->
    <!-- eClickURL              = %%TTD_CLK%% -->
    <!-- eImpressionId          = %%TTD_IMPRESSIONID%% -->
    <!-- eDeviceType            = %%TTD_DEVICETYPE%% -->
    <!-- eTagId                 = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = TradeDesk -->
    <!-- eCreativeId            = %%TTD_CREATIVEID%% -->
    <!-- ePlacementId           = %%TTD_ADGROUPID%% -->
    <!-- eCampaignId            = %%TTD_CAMPAIGNID%% -->
    <!-- eAdvertiserId          = %%TTD_ADVERTISERID%% -->
    <!-- eSiteName              = %%TTD_SITE%% -->
    <!-- ePublisherId           = %%TTD_PARTNERID%% -->
    <!-- ePublisherName         = %%TTD_SUPPLYVENDOR%% -->
    <!-- eGPSLat                = %%TTD_LAT%% -->
    <!-- eGPSLng                = %%TTD_LONG%% -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eIFAIOS                = %%TTD_DEVICEID%% -->
    <!-- eIFAAndroid            = %%TTD_DEVICEID%% -->
    <!-- eClickURL              = %%TTD_CLK%% -->
    <!-- eImpressionId          = %%TTD_IMPRESSIONID%% -->
    <!-- eDeviceType            = %%TTD_DEVICETYPE%% -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = TradeDesk --><!-- eCreativeId = %%TTD_CREATIVEID%% --><!-- ePlacementId = %%TTD_ADGROUPID%% --><!-- eCampaignId = %%TTD_CAMPAIGNID%% --><!-- eTagId = \${TAG_ID} --><!-- eAdvertiserId = %%TTD_ADVERTISERID%% --><!-- eSiteName = %%TTD_SITE%% --><!-- ePublisherId = %%TTD_PARTNERID%% --><!-- ePublisherName = %%TTD_SUPPLYVENDOR%% --><!-- eGPSLat = %%TTD_LAT%% --><!-- eGPSLng = %%TTD_LONG%% --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eIFAIOS = %%TTD_DEVICEID%% --><!-- eIFAAndroid = %%TTD_DEVICEID%% --><!-- eClickURL = %%TTD_CLK%% --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- eImpressionId = %%TTD_IMPRESSIONID%% --><!-- eDeviceType = %%TTD_DEVICETYPE%% --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = TradeDesk --><!-- eCreativeId = %%TTD_CREATIVEID%% --><!-- ePlacementId = %%TTD_ADGROUPID%% --><!-- eCampaignId = %%TTD_CAMPAIGNID%% --><!-- eTagId = \${TAG_ID} --><!-- eAdvertiserId = %%TTD_ADVERTISERID%% --><!-- eSiteName = %%TTD_SITE%% --><!-- ePublisherId = %%TTD_PARTNERID%% --><!-- ePublisherName = %%TTD_SUPPLYVENDOR%% --><!-- eGPSLat = %%TTD_LAT%% --><!-- eGPSLng = %%TTD_LONG%% --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eIFAIOS = %%TTD_DEVICEID%% --><!-- eIFAAndroid = %%TTD_DEVICEID%% --><!-- eClickURL = %%TTD_CLK%% --><!-- eImpressionId = %%TTD_IMPRESSIONID%% --><!-- eDeviceType = %%TTD_DEVICETYPE%% -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Amobee',
        id: 8,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer      = Amobee -->
    <!-- eCreativeId    = $!{CREATIVE_ID} -->
    <!-- eLineItemId    = $!{LINE_ITEM_ID} -->
    <!-- eSiteName      = $!{SITE_URL}  -->
    <!-- ePublisherId   = $!{INVENTORY_SOURCE_ID}  -->
    <!-- eGPSLat        = $!{USER_LAT} -->
    <!-- eGPSLng        = $!{USER_LONG} -->
    <!-- eCreativeSize  = {{getWidth}}x{{getHeight}} -->
    <!-- eIFAIOS        = $!{IFA} -->
    <!-- eIFAAndroid    = $!{IFA} -->
    <!-- eClickURL      = XXCLICK_FORM_URL[]XX -->
    <!-- eTagId         = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer      = Amobee -->
    <!-- eCreativeId    = $!{CREATIVE_ID} -->
    <!-- eLineItemId    = $!{LINE_ITEM_ID} -->
    <!-- eSiteName      = $!{SITE_URL}  -->
    <!-- ePublisherId   = $!{INVENTORY_SOURCE_ID}  -->
    <!-- eGPSLat        = $!{USER_LAT} -->
    <!-- eGPSLng        = $!{USER_LONG} -->
    <!-- eCreativeSize  = {{getWidth}}x{{getHeight}} -->
    <!-- eIFAIOS        = $!{IFA} -->
    <!-- eIFAAndroid    = $!{IFA} -->
    <!-- eClickURL      = XXCLICK_FORM_URL[]XX -->
    <!-- eTagId         = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Amobee --><!-- eCreativeId = $!{CREATIVE_ID} --><!-- eLineItemId = $!{LINE_ITEM_ID} --><!-- eSiteName = $!{SITE_URL}  --><!-- eTagId = \${TAG_ID} --><!-- ePublisherId   = $!{INVENTORY_SOURCE_ID}  --><!-- eGPSLat = $!{USER_LAT} --><!-- eGPSLng = $!{USER_LONG} --><!-- eCreativeSize  = {{getWidth}}x{{getHeight}} --><!-- eIFAIOS = $!{IFA} --><!-- eIFAAndroid    = $!{IFA} --><!-- eClickURL = XXCLICK_FORM_URL[]XX --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Amobee --><!-- eCreativeId = $!{CREATIVE_ID} --><!-- eLineItemId = $!{LINE_ITEM_ID} --><!-- eSiteName = $!{SITE_URL}  --><!-- eTagId = \${TAG_ID} --><!-- ePublisherId   = $!{INVENTORY_SOURCE_ID}  --><!-- eGPSLat = $!{USER_LAT} --><!-- eGPSLng = $!{USER_LONG} --><!-- eCreativeSize  = {{getWidth}}x{{getHeight}} --><!-- eIFAIOS = $!{IFA} --><!-- eIFAAndroid = $!{IFA} --><!-- eClickURL = XXCLICK_FORM_URL[]XX --><{{simpliTagScript}}</div>'
      },
      {
        name: 'MediaMath',
        id: 9,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer                  =  Media Math -->
    <!-- eAdvertiserId              = [AD_ATTR.advertiser] -->
    <!-- eCreativeId                = [AD_ATTR.creative] -->
    <!-- ePlacementId               = [BID_ATTR.app_name] -->
    <!-- eSiteId                    = [BID_ATTR.site_id] -->
    <!-- eSiteName                  = [BID_ATTR.page_url] -->
    <!-- ePublisherId               = [BID_ATTR.pub_id] -->
    <!-- eLineItemId                = [AD_ATTR.strategy] -->
    <!-- eBundleId                  = [BID_ATTR.app_id] -->
    <!-- eDBMExchangeId             = [BID_ATTR.exchange_id] -->
    <!-- eSiteName                  = [BID_ATTR.site] -->
    <!-- eDestinationUrl            = [BID_ATTR.app_store_url] -->
    <!-- eCreativeSizeW             = {{getWidth}} -->
    <!-- eCreativeSizeH             = {{getHeight}} -->
    <!-- eCampaignId                = [AD_ATTR.campaign] -->
    <!-- ePlacementId               = [AD_ATTR.strategy] -->
    <!-- eClickURL                  = [UNENCODED_CLICK_REDIRECT] -->
    <!-- eGPSLat                    = simpliVars.eGPSLat -->
    <!-- eGPSLng                    = simpliVars.eGPSLng -->

    <!-- eMediaMathReferrer         = [BID_ATTR.referrer] -->
    <!-- eMediaMathExchangeId       = [BID_ATTR.exchange_id] -->
    <!-- eMediaMathSiteDomain       = [BID_ATTR.site] -->
    <!-- eMediaMathAppStoreURL      = [BID_ATTR.app_store_url] -->
    <!-- eMediaMathAdWidth          = [AD_ATTR.width] -->
    <!-- eMediaMathAdHeight         = [AD_ATTR.height] -->
    <!-- eTagId                     = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser           = {{Advertiser}} -->
    <!-- pdsqdxCampaign             = {{CampaignName}} -->
    <!-- pdsqdxPlacement            = {{PlacementName}} -->
    <!-- pdsqdxFormat               = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL      = {{FallBackUrl}} -->

    <!-- pdsqdx3PID   = {{3P_ID}} -->

    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->

    <script>
        var simpliVars = (function(){
            var coordinates = "[BID_ATTR.lat_long]".split(",");
            return {
                eGPSLat: (coordinates.length == 2) ? coordinates[0] : "",
                eGPSLng: (coordinates.length == 2) ? coordinates[1] : ""
            };
        })();

        var tagVars = (function (rootElem) {
            var iterator = document.createNodeIterator(rootElem, NodeFilter.SHOW_COMMENT, (function(){return NodeFilter.FILTER_ACCEPT}), false);
            var curNode;
            while (curNode = iterator.nextNode()) {
                Object.keys(simpliVars).forEach(function(k, i) {
                    curNode.nodeValue = curNode.nodeValue.replace('simpliVars.'+k, simpliVars[k]);
                });
            }
        })(document.currentScript.parentElement);
    <\/script>

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer                  =  Media Math -->
    <!-- eAdvertiserId              = [AD_ATTR.advertiser] -->
    <!-- eCreativeId                = [AD_ATTR.creative] -->
    <!-- ePlacementId               = [BID_ATTR.app_name] -->
    <!-- eSiteId                    = [BID_ATTR.site_id] -->
    <!-- eSiteName                  = [BID_ATTR.page_url] -->
    <!-- ePublisherId               = [BID_ATTR.pub_id] -->
    <!-- eLineItemId                = [AD_ATTR.strategy] -->
    <!-- eBundleId                  = [BID_ATTR.app_id] -->
    <!-- eDBMExchangeId             = [BID_ATTR.exchange_id] -->
    <!-- eSiteName                  = [BID_ATTR.site] -->
    <!-- eDestinationUrl            = [BID_ATTR.app_store_url] -->
    <!-- eCreativeSizeW             = {{getWidth}} -->
    <!-- eCreativeSizeH             = {{getHeight}} -->
    <!-- eCampaignId                = [AD_ATTR.campaign] -->
    <!-- ePlacementId               = [AD_ATTR.strategy] -->
    <!-- eClickURL                  = [UNENCODED_CLICK_REDIRECT] -->
    <!-- eGPSLat                    = simpliVars.eGPSLat -->
    <!-- eGPSLng                    = simpliVars.eGPSLng -->

    <!-- eMediaMathReferrer         = [BID_ATTR.referrer] -->
    <!-- eMediaMathExchangeId       = [BID_ATTR.exchange_id] -->
    <!-- eMediaMathSiteDomain       = [BID_ATTR.site] -->
    <!-- eMediaMathAppStoreURL      = [BID_ATTR.app_store_url] -->
    <!-- eMediaMathAdWidth          = [AD_ATTR.width] -->
    <!-- eMediaMathAdHeight         = [AD_ATTR.height] -->
    <!-- eTagId                     = \${TAG_ID} -->

    <script>
        var simpliVars = (function(){
            var coordinates = "[BID_ATTR.lat_long]".split(",");
            return {
                eGPSLat: (coordinates.length == 2) ? coordinates[0] : "",
                eGPSLng: (coordinates.length == 2) ? coordinates[1] : ""
            };
        })();

        var tagVars = (function (rootElem) {
            var iterator = document.createNodeIterator(rootElem, NodeFilter.SHOW_COMMENT, (function(){return NodeFilter.FILTER_ACCEPT}), false);
            var curNode;
            while (curNode = iterator.nextNode()) {
                Object.keys(simpliVars).forEach(function(k, i) {
                    curNode.nodeValue = curNode.nodeValue.replace('simpliVars.'+k, simpliVars[k]);
                });
            }
        })(document.currentScript.parentElement);
    <\/script>

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer=  Media Math --><!-- eAdvertiserId = [AD_ATTR.advertiser] --><!-- eCreativeId = [AD_ATTR.creative] --><!-- ePlacementId = [BID_ATTR.app_name] --><!-- eTagId = \${TAG_ID} --><!-- eSiteId = [BID_ATTR.site_id] --><!-- eSiteName = [BID_ATTR.page_url] --><!-- ePublisherId = [BID_ATTR.pub_id] --><!-- eLineItemId = [AD_ATTR.strategy] --><!-- eBundleId = [BID_ATTR.app_id] --><!-- eDBMExchangeId = [BID_ATTR.exchange_id] --><!-- eSiteName = [BID_ATTR.site] --><!-- eDestinationUrl = [BID_ATTR.app_store_url] --><!-- eCreativeSizeW = {{getWidth}} --><!-- eCreativeSizeH = {{getHeight}} --><!-- eCampaignId = [AD_ATTR.campaign] --><!-- ePlacementId = [AD_ATTR.strategy] --><!-- eClickURL = [UNENCODED_CLICK_REDIRECT] --><!-- eGPSLat = simpliVars.eGPSLat --><!-- eGPSLng = simpliVars.eGPSLng --><!-- eMediaMathReferrer = [BID_ATTR.referrer] --><!-- eMediaMathExchangeId = [BID_ATTR.exchange_id] --><!-- eMediaMathSiteDomain = [BID_ATTR.site] --><!-- eMediaMathAppStoreURL = [BID_ATTR.app_store_url] --><!-- eMediaMathAdWidth = [AD_ATTR.width] --><!-- eMediaMathAdHeight = [AD_ATTR.height] --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} --><script> var simpliVars = (function(){var coordinates = "[BID_ATTR.lat_long]".split(",");return {eGPSLat: (coordinates.length == 2) ? coordinates[0] : "",eGPSLng: (coordinates.length == 2) ? coordinates[1] : ""};})();var tagVars = (function (rootElem) {var iterator = document.createNodeIterator(rootElem, NodeFilter.SHOW_COMMENT, (function(){return NodeFilter.FILTER_ACCEPT}), false);var curNode;while (curNode = iterator.nextNode()) {Object.keys(simpliVars).forEach(function(k, i) {curNode.nodeValue = curNode.nodeValue.replace(\'simpliVars.\'+k, simpliVars[k]);});}})(document.currentScript.parentElement);<\/script>{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer =  Media Math --><!-- eAdvertiserId = [AD_ATTR.advertiser] --><!-- eCreativeId = [AD_ATTR.creative] --><!-- ePlacementId = [BID_ATTR.app_name] --><!-- eTagId = \${TAG_ID} --><!-- eSiteId = [BID_ATTR.site_id] --><!-- eSiteName = [BID_ATTR.page_url] --><!-- ePublisherId = [BID_ATTR.pub_id] --><!-- eLineItemId= [AD_ATTR.strategy] --><!-- eBundleId = [BID_ATTR.app_id] --><!-- eDBMExchangeId = [BID_ATTR.exchange_id] --><!-- eSiteName = [BID_ATTR.site] --><!-- eDestinationUrl = [BID_ATTR.app_store_url] --><!-- eCreativeSizeW = {{getWidth}} --><!-- eCreativeSizeH = {{getHeight}} --><!-- eCampaignId = [AD_ATTR.campaign] --><!-- ePlacementId = [AD_ATTR.strategy] --><!-- eClickURL = [UNENCODED_CLICK_REDIRECT] --><!-- eGPSLat = simpliVars.eGPSLat --><!-- eGPSLng = simpliVars.eGPSLng --><!-- eMediaMathReferrer = [BID_ATTR.referrer] --><!-- eMediaMathExchangeId = [BID_ATTR.exchange_id] --><!-- eMediaMathSiteDomain = [BID_ATTR.site] --><!-- eMediaMathAppStoreURL = [BID_ATTR.app_store_url] --><!-- eMediaMathAdWidth = [AD_ATTR.width] --><!-- eMediaMathAdHeight = [AD_ATTR.height] --><script> var simpliVars = (function(){ var coordinates = "[BID_ATTR.lat_long]".split(","); return {eGPSLat: (coordinates.length == 2) ? coordinates[0] : "", eGPSLng: (coordinates.length == 2) ? coordinates[1] : "" }; })(); var tagVars = (function (rootElem) { var iterator = document.createNodeIterator(rootElem, NodeFilter.SHOW_COMMENT, (function(){return NodeFilter.FILTER_ACCEPT}), false);var curNode; while (curNode = iterator.nextNode()) {Object.keys(simpliVars).forEach(function(k, i) {curNode.nodeValue = curNode.nodeValue.replace(\'simpliVars.\'+k, simpliVars[k]);});}})(document.currentScript.parentElement);<\/script>{{simpliTagScript}}</div>'
      },
      {
        name: 'Adobe (TubeMogul)',
        id: 10,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer                  = Adobe -->
    <!-- ePlacementId               = \${TM_PLACEMENT_ID_NUM} -->
    <!-- eSiteId                    = \${TM_SITE_ID_NUM} -->
    <!-- eSiteName                  = \${TM_SITE_DOMAIN_URLENC} -->
    <!-- eCampaignId                = \${TM_CAMPAIGN_ID_NUM} -->
    <!-- eClickURL                  = \${TM_CLICK_URL} -->
    <!-- eCreativeSize              = {{getWidth}}x{{getHeight}} -->
    <!-- eTagId                     = \${TAG_ID} -->

    <!-- pdsqdxAdvertiser           = {{Advertiser}} -->
    <!-- pdsqdxCampaign             = {{CampaignName}} -->
    <!-- pdsqdxPlacement            = {{PlacementName}} -->
    <!-- pdsqdxFormat               = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL      = {{FallBackUrl}} -->

    <!-- pdsqdx3PID                 = {{3P_ID}} -->

    <!-- pdsqdxCID                  = {{CampaignID}} -->
    <!-- pdsqdxPID                  = {{PlacementID}} -->
    <!-- pdsqdxECRID                = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID                  = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer                  = Adobe -->
    <!-- ePlacementId               = \${TM_PLACEMENT_ID_NUM} -->
    <!-- eSiteId                    = \${TM_SITE_ID_NUM} -->
    <!-- eSiteName                  = \${TM_SITE_DOMAIN_URLENC} -->
    <!-- eCampaignId                = \${TM_CAMPAIGN_ID_NUM} -->
    <!-- eClickURL                  = \${TM_CLICK_URL} -->
    <!-- eCreativeSize              = {{getWidth}}x{{getHeight}} -->
    <!-- eTagId                     = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Adobe --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId= ${TM_PLACEMENT_ID_NUM} --><!-- eSiteId = ${TM_SITE_ID_NUM} --><!-- eSiteName = ${TM_SITE_DOMAIN_URLENC} --><!-- eCampaignId = ${TM_CAMPAIGN_ID_NUM} --><!-- eClickURL = ${TM_CLICK_URL} --><!-- eCreativeSize  = {{getWidth}}x{{getHeight}} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Adobe --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId = ${TM_PLACEMENT_ID_NUM} --><!-- eSiteId = ${TM_SITE_ID_NUM} --><!-- eSiteName = ${TM_SITE_DOMAIN_URLENC} --><!-- eCampaignId = ${TM_CAMPAIGN_ID_NUM} --><!-- eClickURL = ${TM_CLICK_URL} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Cannavu',
        id: 11,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Cannavu -->
    <!-- eCreativeId            = {adId} -->
    <!-- ePlacementId           = {dealId} -->
    <!-- eCampaignId            = {campaignId} -->
    <!-- eSiteName              = {domain} -->
    <!-- ePublisherId           = {networkId} -->
    <!-- eAdvertiserId          = {advertiserId} -->
    <!-- eAuctionId             = {auctionId} -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eIFAIOS                = {ifa} -->
    <!-- eIFAAndroid            = {idfa} -->
    <!-- eClickURL              = {clickMacro} -->
    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->
    <!-- pdsqdx3PID     = {{3P_ID}} -->
    <!-- pdsqdxCID = {{CampaignID}} -->
    <!-- pdsqdxPID = {{PlacementID}} -->
    <!-- pdsqdxECRID = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID = {{FormatID}} -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Cannavu -->
    <!-- eCreativeId            = {adId} -->
    <!-- ePlacementId           = {dealId} -->
    <!-- eCampaignId            = {campaignId} -->
    <!-- eSiteName              = {domain} -->
    <!-- ePublisherId           = {networkId} -->
    <!-- eAdvertiserId          = {advertiserId} -->
    <!-- eAuctionId             = {auctionId} -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eIFAIOS                = {ifa} -->
    <!-- eIFAAndroid            = {idfa} -->
    <!-- eClickURL              = {clickMacro} -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Cannavu --><!-- eCreativeId = {adId} --><!-- ePlacementId = {dealId} --><!-- eCampaignId = {campaignId} --><!-- eTagId = \${TAG_ID} --><!-- eSiteName = {domain} --><!-- ePublisherId = {networkId} --><!-- eAdvertiserId = {advertiserId} --><!-- eAuctionId = {auctionId} --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eIFAIOS = {ifa} --><!-- eIFAAndroid = {idfa} --><!-- eClickURL = {clickMacro} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer= Cannavu --><!-- eCreativeId = {adId} --><!-- ePlacementId = {dealId} --><!-- eCampaignId = {campaignId} --><!-- eTagId = \${TAG_ID} --><!-- eSiteName = {domain} --><!-- ePublisherId = {networkId} --><!-- eAdvertiserId = {advertiserId} --><!-- eAuctionId = {auctionId} --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eIFAIOS = {ifa} --><!-- eIFAAndroid = {idfa} --><!-- eClickURL = {clickMacro} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Adelphic/Viant',
        id: 12,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Adelphic/Viant -->
    <!-- eCreativeId            = \${ADELPHIC_CREATIVEID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- ePlacementId           = \${ADELPHIC_ADORDERID} -->
    <!-- eCampaignId            = \${ADELPHIC_CAMPAIGNID} -->
    <!-- eSiteId                = \${ADELPHIC_SITEID} -->
    <!-- eSiteName              = \${ADELPHIC_SITELET_URL_ENC} -->
    <!-- ePublisherId           = \${ADELPHIC_PUBID} -->
    <!-- eAdvertiserId          = \${ADELPHIC_ADVERTISERID} -->
    <!-- eClickURL              = \${ADELPHIC_CLICK_REDIRECT_PROVIDED} -->
    <!-- eDeviceType            = \${ADELPHIC_DEVICE_TYPE} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->
    <!-- pdsqdx3PID             = {{3P_ID}} -->
    <!-- pdsqdxCID              = {{CampaignID}} -->
    <!-- pdsqdxPID              = {{PlacementID}} -->
    <!-- pdsqdxECRID            = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID              = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Adelphic/Viant -->
    <!-- eCreativeId            = \${ADELPHIC_CREATIVEID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- ePlacementId           = \${ADELPHIC_ADORDERID} -->
    <!-- eCampaignId            = \${ADELPHIC_CAMPAIGNID} -->
    <!-- eSiteId                = \${ADELPHIC_SITEID} -->
    <!-- eSiteName              = \${ADELPHIC_SITELET_URL_ENC} -->
    <!-- ePublisherId           = \${ADELPHIC_PUBID} -->
    <!-- eAdvertiserId          = \${ADELPHIC_ADVERTISERID} -->
    <!-- eClickURL              = \${ADELPHIC_CLICK_REDIRECT_PROVIDED} -->
    <!-- eDeviceType            = \${ADELPHIC_DEVICE_TYPE} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Adelphic/Viant --><!-- eCreativeId = ${ADELPHIC_CREATIVEID} --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId = ${ADELPHIC_ADORDERID} --><!-- eCampaignId = ${ADELPHIC_CAMPAIGNID} --><!-- eSiteId = ${ADELPHIC_SITEID} --><!-- eSiteName = ${ADELPHIC_SITELET_URL_ENC} --><!-- ePublisherId = ${ADELPHIC_PUBID} --><!-- eAdvertiserId = ${ADELPHIC_ADVERTISERID} --><!-- eClickURL = ${ADELPHIC_CLICK_REDIRECT_PROVIDED} --><!-- eDeviceType = ${ADELPHIC_DEVICE_TYPE} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Adelphic/Viant --><!-- eCreativeId = ${ADELPHIC_CREATIVEID} --><!-- eTagId = \${TAG_ID} --><!-- ePlacementId = ${ADELPHIC_ADORDERID} --><!-- eCampaignId = ${ADELPHIC_CAMPAIGNID} --><!-- eSiteId = ${ADELPHIC_SITEID} --><!-- eSiteName = ${ADELPHIC_SITELET_URL_ENC} --><!-- ePublisherId = ${ADELPHIC_PUBID} --><!-- eAdvertiserId = ${ADELPHIC_ADVERTISERID} --><!-- eClickURL = ${ADELPHIC_CLICK_REDIRECT_PROVIDED} --><!-- eDeviceType = ${ADELPHIC_DEVICE_TYPE} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Basis',
        id: 13,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Basis -->
    <!-- eCreativeId            = {adId} -->
    <!-- ePlacementId           = {dealId} -->
    <!-- eCampaignId            = {campaignId} -->
    <!-- eSiteName              = {domain} -->
    <!-- ePublisherId           = {networkId} -->
    <!-- eAdvertiserId          = {advertiserId} -->
    <!-- eAuctionId             = {auctionId} -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eIFAIOS                = {ifa} -->
    <!-- eIFAAndroid            = {idfa} -->
    <!-- eClickURL              = {clickMacro} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID             = {{3P_ID}} -->

    <!-- pdsqdxCID              = {{CampaignID}} -->
    <!-- pdsqdxPID              = {{PlacementID}} -->
    <!-- pdsqdxECRID            = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID              = {{FormatID}} -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = Basis -->
    <!-- eCreativeId            = {adId} -->
    <!-- ePlacementId           = {dealId} -->
    <!-- eCampaignId            = {campaignId} -->
    <!-- eSiteName              = {domain} -->
    <!-- ePublisherId           = {networkId} -->
    <!-- eAdvertiserId          = {advertiserId} -->
    <!-- eAuctionId             = {auctionId} -->
    <!-- eCreativeSize          = {{getWidthHeight}} -->
    <!-- eIFAIOS                = {ifa} -->
    <!-- eIFAAndroid            = {idfa} -->
    <!-- eClickURL              = {clickMacro} -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Basis --><!-- eCreativeId = {adId} --><!-- ePlacementId = {dealId} --><!-- eCampaignId = {campaignId} --><!-- eTagId = \${TAG_ID} --><!-- eSiteName = {domain} --><!-- ePublisherId = {networkId} --><!-- eAdvertiserId = {advertiserId} --><!-- eAuctionId = {auctionId} --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eIFAIOS = {ifa} --><!-- eIFAAndroid = {idfa} --><!-- eClickURL = {clickMacro} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Basis --><!-- eCreativeId = {adId} --><!-- ePlacementId = {dealId} --><!-- eCampaignId = {campaignId} --><!-- eTagId = \${TAG_ID} --><!-- eSiteName = {domain} --><!-- ePublisherId = {networkId} --><!-- eAdvertiserId = {advertiserId} --><!-- eAuctionId = {auctionId} --><!-- eCreativeSize = {{getWidthHeight}} --><!-- eIFAIOS = {ifa} --><!-- eIFAAndroid = {idfa} --><!-- eClickURL = {clickMacro} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'DeepIntent DSP',
        id: 14,
        simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DeepIntent DSP -->
    <!-- eCampaignId            = \${CAMPAIGN_ID} -->
    <!-- eCreativeId            = \${CREATIVE_ID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- eSiteName              = \${INVENTORY_ID} -->
    <!-- ePublisherId           = \${SELLER_ID} -->
    <!-- ePublisherName         = \${INVENTORY_ID} -->
    <!-- eIFAIOS                = \${DEVICE_ID} -->
    <!-- eIFAAndroid            = \${DEVICE_ID} -->
    <!-- eClickURL              = \${CLICK_TRACKER} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->

    <!-- pdsqdx3PID             = {{3P_ID}} -->

    <!-- pdsqdxCID              = {{CampaignID}} -->
    <!-- pdsqdxPID              = {{PlacementID}} -->
    <!-- pdsqdxECRID            = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID              = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer              = DeepIntent DSP -->
    <!-- eCampaignId            = \${CAMPAIGN_ID} -->
    <!-- eCreativeId            = \${CREATIVE_ID} -->
    <!-- eTagId                 = \${TAG_ID} -->
    <!-- eSiteName              = \${INVENTORY_ID} -->
    <!-- ePublisherId           = \${SELLER_ID} -->
    <!-- ePublisherName         = \${INVENTORY_ID} -->
    <!-- eIFAIOS                = \${DEVICE_ID} -->
    <!-- eIFAAndroid            = \${DEVICE_ID} -->
    <!-- eClickURL              = \${CLICK_TRACKER} -->
    <!-- eCreativeSize          = {{getWidth}}x{{getHeight}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = DeepIntent DSP --><!-- eCampaignId = ${CAMPAIGN_ID} --><!-- eCreativeId = ${CREATIVE_ID} --><!-- eTagId = \${TAG_ID} --><!-- eSiteName  = ${INVENTORY_ID} --><!-- ePublisherId = ${SELLER_ID} --><!-- ePublisherName = ${INVENTORY_ID} --><!-- eIFAIOS = ${DEVICE_ID} --><!-- eIFAAndroid = ${DEVICE_ID} --><!-- eClickURL = ${CLICK_TRACKER} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = DeepIntent DSP --><!-- eCampaignId  = ${CAMPAIGN_ID} --><!-- eCreativeId  = ${CREATIVE_ID} --><!-- eTagId = \${TAG_ID} --><!-- eSiteName  = ${INVENTORY_ID} --><!-- ePublisherId  = ${SELLER_ID} --><!-- ePublisherName  = ${INVENTORY_ID} --><!-- eIFAIOS = ${DEVICE_ID} --><!-- eIFAAndroid = ${DEVICE_ID} --><!-- eClickURL  = ${CLICK_TRACKER} --><!-- eCreativeSize = {{getWidth}}x{{getHeight}} -->{{simpliTagScript}}</div>'
      },
      {
        name: 'Stack Adapt DSP',
        id: 15,
        simpli_tag_template: `<div class='simpli-tag'>
    <!-- eAdServer              = Stack Adapt DSP -->
    <!-- eSiteName              = {SA_REF_DOMAIN} -->
    <!-- eSiteId                = {SA_REF_ID} -->
    <!-- ePublisherId           = {SA_SOURCE_ID} -->
    <!-- eAdvertiserId          = {SA_ADVERTISER_ID} -->
    <!-- eCreativeId            = {SA_CREATIVE_ID} -->
    <!-- ePlacementId           = {SA_PLACEMENT_ID} -->
    <!-- eCampaignId            = {SA_CAMPAIGN_ID} -->
    <!-- eCampaignName          = {SA_CAMPAIGN_NAME} -->
    <!-- eLineItemId            = {SA_LINE_ITEM_ID} -->
    <!-- eUserId                = {SA_USER_AGENT} -->
    <!-- eClickURL              = {SA_CLICK_URL} -->
    <!-- eCreativeSizeW         = {{getWidth}} -->
    <!-- eCreativeSizeH         = {{getHeight}} -->
    <!-- eIFAIOS                = {SA_DEVICE_ID} -->
    <!-- eIFAAndroid            = {SA_DEVICE_ID} -->
    <!-- eGPSLat                = {SA_LOCATION_LAT} -->
    <!-- eGPSLng                = {SA_LOCATION_LONG} -->
    <!-- eBundleId              = {SA_BUNDLE_ID} -->
    <!-- eStackAdaptChannelType  = {SA_CHANNEL_TYPE} -->
    <!-- eStackAdaptSubAdId      = {SA_SUB_ADVERTISER_ID} -->
    <!-- eStackAdaptClickURLEnc  = {SA_CLICK_URL_ENC} -->
    <!-- eStackAdaptDoNotTrack   = {SA_DO_NOT_TRACK} -->
    <!-- eStackAdaptAppName      = {SA_APP_NAME} -->
    <!-- eStackAdaptAppStoreURL  = {SA_STORE_URL} -->
    <!-- eStackAdaptAppVersion   = {SA_APP_VERSION} -->
    <!-- eStackAdaptStoreURL     = {SA_STORE_URL} -->
    <!-- eStackAdaptDeviceOS     = {SA_DEVICE_OS} -->
    <!-- eStackAdaptDeviceModel  = {SA_DEVICE_MODEL} -->
    <!-- eStackAdaptIDFAMd5      = {SA_IDFA_MD5} -->
    <!-- eStackAdaptIDFASha      = {SA_IDFA_SHA} -->
    <!-- eStackAdaptGeoState     = {SA_GEO_STATE} -->
    <!-- eStackAdaptGeoStName    = {SA_GEO_STATE_NAME} -->
    <!-- eStackAdaptGeoDMA       = {SA_GEO_DMA} -->
    <!-- eStackAdaptGeoCity      = {SA_GEO_CITY} -->
    <!-- eStackAdaptGeoPostal    = {SA_GEO_POSTAL} -->
    <!-- eStackAdaptGeoCountry   = {SA_GEO_COUNTRY} -->
    <!-- eStackAdaptCreativeNm   = {SA_CREATIVE_NAME} -->
    <!-- eStackAdaptCreativeH    = {SA_CREATIVE_HEIGHT} -->
    <!-- eStackAdaptCreativeW    = {SA_CREATIVE_WIDTH} -->
    <!-- eStackAdaptDayOfWeek    = {SA_DAY_OF_WEEK} -->
    <!-- eStackAdaptMonth        = {SA_MONTH} -->
    <!-- eStackAdaptPostBackId   = {SA_POSTBACK_ID} -->
    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->
    <!-- pdsqdx3PID             = {{3P_ID}} -->
    <!-- pdsqdxCID              = {{CampaignID}} -->
    <!-- pdsqdxPID              = {{PlacementID}} -->
    <!-- pdsqdxECRID            = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID              = {{FormatID}} -->
    <!-- eTagId                 = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer               = Stack Adapt DSP -->
    <!-- eSiteName               = {SA_REF_DOMAIN} -->
    <!-- eSiteId                 = {SA_REF_ID} -->
    <!-- ePublisherId            = {SA_SOURCE_ID} -->
    <!-- eAdvertiserId           = {SA_ADVERTISER_ID} -->
    <!-- eCreativeId             = {SA_CREATIVE_ID} -->
    <!-- ePlacementId            = {SA_PLACEMENT_ID} -->
    <!-- eCampaignId             = {SA_CAMPAIGN_ID} -->
    <!-- eCampaignName           = {SA_CAMPAIGN_NAME} -->
    <!-- eLineItemId             = {SA_LINE_ITEM_ID} -->
    <!-- eUserId                 = {SA_USER_AGENT} -->
    <!-- eClickURL               = {SA_CLICK_URL} -->
    <!-- eCreativeSizeW          = {{getWidth}} -->
    <!-- eCreativeSizeH          = {{getHeight}} -->
    <!-- eIFAIOS                 = {SA_DEVICE_ID} -->
    <!-- eIFAAndroid             = {SA_DEVICE_ID} -->
    <!-- eGPSLat                 = {SA_LOCATION_LAT} -->
    <!-- eGPSLng                 = {SA_LOCATION_LONG} -->
    <!-- eBundleId               = {SA_BUNDLE_ID} -->
    <!-- eStackAdaptChannelType  = {SA_CHANNEL_TYPE} -->
    <!-- eStackAdaptSubAdId      = {SA_SUB_ADVERTISER_ID} -->
    <!-- eStackAdaptClickURLEnc  = {SA_CLICK_URL_ENC} -->
    <!-- eStackAdaptDoNotTrack   = {SA_DO_NOT_TRACK} -->
    <!-- eStackAdaptAppName      = {SA_APP_NAME} -->
    <!-- eStackAdaptAppStoreURL  = {SA_STORE_URL} -->
    <!-- eStackAdaptAppVersion   = {SA_APP_VERSION} -->
    <!-- eStackAdaptStoreURL     = {SA_STORE_URL} -->
    <!-- eStackAdaptDeviceOS     = {SA_DEVICE_OS} -->
    <!-- eStackAdaptDeviceModel  = {SA_DEVICE_MODEL} -->
    <!-- eStackAdaptIDFAMd5      = {SA_IDFA_MD5} -->
    <!-- eStackAdaptIDFASha      = {SA_IDFA_SHA} -->
    <!-- eStackAdaptGeoState     = {SA_GEO_STATE} -->
    <!-- eStackAdaptGeoStName    = {SA_GEO_STATE_NAME} -->
    <!-- eStackAdaptGeoDMA       = {SA_GEO_DMA} -->
    <!-- eStackAdaptGeoCity      = {SA_GEO_CITY} -->
    <!-- eStackAdaptGeoPostal    = {SA_GEO_POSTAL} -->
    <!-- eStackAdaptGeoCountry   = {SA_GEO_COUNTRY} -->
    <!-- eStackAdaptCreativeNm   = {SA_CREATIVE_NAME} -->
    <!-- eStackAdaptCreativeH    = {SA_CREATIVE_HEIGHT} -->
    <!-- eStackAdaptCreativeW    = {SA_CREATIVE_WIDTH} -->
    <!-- eStackAdaptDayOfWeek    = {SA_DAY_OF_WEEK} -->
    <!-- eStackAdaptMonth        = {SA_MONTH} -->
    <!-- eStackAdaptPostBackId   = {SA_POSTBACK_ID} -->
    <!-- eTagId                  = \${TAG_ID} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Stack Adapt DSP --><!-- eSiteName = {SA_REF_DOMAIN} --><!-- eSiteId = {SA_REF_ID} --><!-- eTagId = \${TAG_ID} --><!-- ePublisherId = {SA_SOURCE_ID} --><!-- eAdvertiserId = {SA_ADVERTISER_ID} --><!-- eCreativeId = {SA_CREATIVE_ID} --><!-- ePlacementId = {SA_PLACEMENT_ID} --><!-- eCampaignId = {SA_CAMPAIGN_ID} --><!-- eCampaignName = {SA_CAMPAIGN_NAME} --><!-- eLineItemId = {SA_LINE_ITEM_ID} --><!-- eUserId = {SA_USER_AGENT} --><!-- eClickURL = {SA_CLICK_URL} --><!-- eCreativeSizeW = {{getWidth}} --><!-- eCreativeSizeH = {{getHeight}} --><!-- eIFAIOS = {SA_DEVICE_ID} --><!-- eIFAAndroid = {SA_DEVICE_ID} --><!-- eGPSLat = {SA_LOCATION_LAT} --><!-- eGPSLng = {SA_LOCATION_LONG} --><!-- eBundleId = {SA_BUNDLE_ID} --><!-- eStackAdaptChannelType = {SA_CHANNEL_TYPE} --><!-- eStackAdaptSubAdId = {SA_SUB_ADVERTISER_ID} --><!-- eStackAdaptClickURLEnc = {SA_CLICK_URL_ENC} --><!-- eStackAdaptDoNotTrack = {SA_DO_NOT_TRACK} --><!-- eStackAdaptAppName = {SA_APP_NAME} --><!-- eStackAdaptAppStoreURL = {SA_STORE_URL} --><!-- eStackAdaptAppVersion = {SA_APP_VERSION} --><!-- eStackAdaptStoreURL = {SA_STORE_URL} --><!-- eStackAdaptDeviceOS = {SA_DEVICE_OS} --><!-- eStackAdaptDeviceModel = {SA_DEVICE_MODEL} --><!-- eStackAdaptIDFAMd5 = {SA_IDFA_MD5} --><!-- eStackAdaptIDFASha = {SA_IDFA_SHA} --><!-- eStackAdaptGeoState = {SA_GEO_STATE} --><!-- eStackAdaptGeoStName = {SA_GEO_STATE_NAME} --><!-- eStackAdaptGeoDMA = {SA_GEO_DMA} --><!-- eStackAdaptGeoCity = {SA_GEO_CITY} --><!-- eStackAdaptGeoPostal = {SA_GEO_POSTAL} --><!-- eStackAdaptGeoCountry = {SA_GEO_COUNTRY} --><!-- eStackAdaptCreativeNm = {SA_CREATIVE_NAME} --><!-- eStackAdaptCreativeH = {SA_CREATIVE_HEIGHT} --><!-- eStackAdaptCreativeW = {SA_CREATIVE_WIDTH} --><!-- eStackAdaptDayOfWeek = {SA_DAY_OF_WEEK} --><!-- eStackAdaptMonth = {SA_MONTH} --><!-- eStackAdaptPostBackId = {SA_POSTBACK_ID} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --><!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
        simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Stack Adapt DSP --><!-- eSiteName = {SA_REF_DOMAIN} --><!-- eSiteId = {SA_REF_ID} --><!-- eTagId = \${TAG_ID} --><!-- ePublisherId = {SA_SOURCE_ID} --><!-- eAdvertiserId = {SA_ADVERTISER_ID} --><!-- eCreativeId = {SA_CREATIVE_ID} --><!-- ePlacementId = {SA_PLACEMENT_ID} --><!-- eCampaignId = {SA_CAMPAIGN_ID} --><!-- eCampaignName = {SA_CAMPAIGN_NAME} --><!-- eLineItemId = {SA_LINE_ITEM_ID} --><!-- eUserId = {SA_USER_AGENT} --><!-- eClickURL = {SA_CLICK_URL} --><!-- eCreativeSizeW = {{getWidth}} --><!-- eCreativeSizeH = {{getHeight}} --><!-- eIFAIOS = {SA_DEVICE_ID} --><!-- eIFAAndroid = {SA_DEVICE_ID} --><!-- eGPSLat = {SA_LOCATION_LAT} --><!-- eGPSLng = {SA_LOCATION_LONG} --><!-- eBundleId = {SA_BUNDLE_ID} --><!-- eStackAdaptChannelType = {SA_CHANNEL_TYPE} --><!-- eStackAdaptSubAdId = {SA_SUB_ADVERTISER_ID} --><!-- eStackAdaptClickURLEnc = {SA_CLICK_URL_ENC} --><!-- eStackAdaptDoNotTrack = {SA_DO_NOT_TRACK} --><!-- eStackAdaptAppName = {SA_APP_NAME} --><!-- eStackAdaptAppStoreURL = {SA_STORE_URL} --><!-- eStackAdaptAppVersion = {SA_APP_VERSION} --><!-- eStackAdaptStoreURL = {SA_STORE_URL} --><!-- eStackAdaptDeviceOS = {SA_DEVICE_OS} --><!-- eStackAdaptDeviceModel = {SA_DEVICE_MODEL} --><!-- eStackAdaptIDFAMd5 = {SA_IDFA_MD5} --><!-- eStackAdaptIDFASha = {SA_IDFA_SHA} --><!-- eStackAdaptGeoState = {SA_GEO_STATE} --><!-- eStackAdaptGeoStName = {SA_GEO_STATE_NAME} --><!-- eStackAdaptGeoDMA = {SA_GEO_DMA} --><!-- eStackAdaptGeoCity = {SA_GEO_CITY} --><!-- eStackAdaptGeoPostal = {SA_GEO_POSTAL} --><!-- eStackAdaptGeoCountry = {SA_GEO_COUNTRY} --><!-- eStackAdaptCreativeNm = {SA_CREATIVE_NAME} --><!-- eStackAdaptCreativeH = {SA_CREATIVE_HEIGHT} --><!-- eStackAdaptCreativeW = {SA_CREATIVE_WIDTH} --><!-- eStackAdaptDayOfWeek = {SA_DAY_OF_WEEK} --><!-- eStackAdaptMonth = {SA_MONTH} --><!-- eStackAdaptPostBackId = {SA_POSTBACK_ID} -->{{simpliTagScript}}</div>'
      },
      {
       name: 'Beeswax DSP',
          id: 16,
          simpli_tag_template: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer               = Beeswax DSP -->
    <!-- eSiteName               = {{SITE_NAME}} -->
    <!-- eSiteId                 = {{SITE_ID}} -->
    <!-- ePublisherId            = {{PUBLISHER_ID}} -->
    <!-- eUniversalCreativeID    = {{AD-ID}} -->
    <!-- eAdvertiserId           = {{ADVERTISER_ID}} -->
    <!-- eCreativeId             = {{{CREATIVE_ID}} -->
    <!-- ePlacementId            = {{PLACEMENT_ID}} -->
    <!-- eCampaignId             = {{CAMPAIGN_ID}} -->
    <!-- eCampaignName           = {{{CAMPAIGN_NAME}} -->
    <!-- eLineItemId             = {{LINE_ITEM_ID}} -->
    <!-- eAuctionId              = {{AUCTION_ID}} -->
    <!-- eAccountId              = {{ACCOUNT_ID}} -->
    <!-- eAppId                  = {{APP_ID}} -->
    <!-- eUserId                 = {{USER_ID}} -->
    <!-- eClickURL               = {{CLICK_URL}} -->
    <!-- eCreativeSizeW          = {{getWidth}} -->
    <!-- eCreativeSizeH          = {{getHeight}} -->
    <!-- eIFAIOS                 = {{IOS_ID}} -->
    <!-- eIFAAndroid             = {{ANDROID_ID}} -->
    <!-- eGPSLat                 = {{LAT}} -->
    <!-- eGPSLng                 = {{LONG}} -->
    <!-- eBundleId               = {{APP_BUNDLE}} -->
    <!-- eTagId                  = \${TAG_ID} -->

    <!-- eBeeswaxAdvertiserName  = {{ADVERTISER_NAME}} -->
    <!-- eBeeswaxCreativeName    = {{CREATIVE_NAME}} -->
    <!-- eBeeswaxLineItemName    = {{LINE_ITEM_NAME}} -->
    <!-- eBeeswaxAge             = {{AGE}} -->
    <!-- eBeeswaxGender          = {{GENDER}} -->
    <!-- eBeeswaxImpressionURL   = {{IMPRESSION_URL}} -->
    <!-- eBeeswaxHOST            = {{MEDIA_HOST}} -->
    <!-- eBeeswaxPage            = {{PAGE}} -->
    <!-- eBeeswaxDomain          = {{DOMAIN}} -->
    <!-- eBeeswaxReferrer        = {{REFERRER}} -->
    <!-- eBeeswaxInventorySrc    = {{INVENTORY_SOURCE}} -->
    <!-- eBeeswaxExchangeHndl    = {{EXCHANGE_HANDLE}} -->
    <!-- eBeeswaxRewarded        = {REWARDED}} -->
    <!-- eBeeswaxAutoPlayBlck    = {{AUTOPLAY_BLOCKED}} -->
    <!-- eBeeswaxUserAgent       = {{USER_AGENT}} -->
    <!-- eBeeswaxIPAddress       = {{IP_ADDRESS}} -->
    <!-- eBeeswaxIPV6            = {{IP_ADDRESS_IPV6}} -->
    <!-- eBeeswaxDoNotTrack      = {{DNT}} -->
    <!-- eBeeswaxAppName         = {{APP_NAME}} -->
    <!-- eBeeswaxAppStoreUrl     = {{APP_STORE_URL}} -->
    <!-- eBeeswaxDeviceOS        = {{PLATFORM_OS}} -->
    <!-- eBeeswaxDeviceModel     = {{DEVICE_MODEL}} -->
    <!-- eBeeswaxDeviceMake      = {{DEVICE_MAKE}} -->
    <!-- eBeeswaxDeviceType      = {{DEVICE_TYPE}} -->
    <!-- eBeeswaxCarrier         = {{PLATFORM_CARRIER}} -->
    <!-- eBeeswaxIDSHA           = {{USER_ID_SHA1}} -->
    <!-- eBeeswaxBidTimeUTC      = {{BID_TIME_UTC}} -->
    <!-- eBeeswaxCountryCode     = {{COUNTRY_CODE}}} -->
    <!-- eBeeswaxMetroCode       = {{METRO_CODE}} -->
    <!-- eBeeswaxZipCode         = {{ZIP_CODE}} -->
    <!-- eBeeswaxGDPRConst       = {{GDPR_CONSENT_STRING}} -->
    <!-- eBeeswaxIsGDPR          = {{IS_GDPR}} -->
    <!-- eBeeswaxIsGDPRConst     = {{IS_GDPR_CONSENTED}} -->
    <!-- eBeeswaxUSPRIVACY       = {{US_PRIVACY_STRING}} -->
    <!-- eBeeswaxBuzzKey         = {{BUZZ_KEY}} -->
    <!-- eBeeswaxCacheBuster     = {{CACHEBUSTER}} -->
    <!-- eBeeswaxEvtStartUrl     = {{EVENT_START_URL}} -->
    <!-- eBeeswaxEvtQ1Url        = {{EVENT_Q1_URL}} -->
    <!-- eBeeswaxEvtMidUrl       = {{EVENT_MID_URL}} -->
    <!-- eBeeswaxEvtQ3Url        = {{EVENT_Q3_URL}} -->
    <!-- eBeeswaxEvtCompleteUrl  = {{EVENT_COMPLETE_URL}} -->
    <!-- eBeeswaxEvtSkipUrl      = {{EVENT_SKIP_URL}} -->
    <!-- eBeeswaxEvtMuteUrl      = {{EVENT_MUTE_URL}} -->
    <!-- eBeeswaxEvtUnmuteUrl    = {{EVENT_UNMUTE_URL}} -->
    <!-- eBeeswaxEvtPauseUrl     = {{EVENT_PAUSE_URL}} -->
    <!-- eBeeswaxEvtResumeUrl    = {{EVENT_RESUME_URL}} -->
    <!-- eBeeswaxEvtFullscreenUrl = {{EVENT_FULLSCREEN_URL}} -->
    <!-- eBeeswaxEvtCloseUrl     = {{EVENT_CLOSE_URL}} -->
    <!-- eBeeswaxPlayerHeight    = {{PLAYER_HEIGHT}} -->
    <!-- eBeeswaxPlayerWidth     = {{PLAYER_WIDTH}} -->

    <!-- pdsqdxAdvertiser       = {{Advertiser}} -->
    <!-- pdsqdxCampaign         = {{CampaignName}} -->
    <!-- pdsqdxPlacement        = {{PlacementName}} -->
    <!-- pdsqdxFormat           = {{Format}} -->
    <!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} -->
    <!-- pdsqdx3PID             = {{3P_ID}} -->
    <!-- pdsqdxCID              = {{CampaignID}} -->
    <!-- pdsqdxPID              = {{PlacementID}} -->
    <!-- pdsqdxECRID            = {{ExternalCreativeID}} -->
    <!-- pdsqdxFID              = {{FormatID}} -->

    {{simpliTagScript}}
</div>`,
            simpli_tag_template_v2: `<div class='pdsqdx-tag'{{ps_tag_id}}>
    <!-- eAdServer               = Beeswax DSP -->
    <!-- eSiteName               = {{SITE_NAME}} -->
    <!-- eSiteId                 = {{SITE_ID}} -->
    <!-- ePublisherId            = {{PUBLISHER_ID}} -->
    <!-- eUniversalCreativeID    = {{AD-ID}} -->
    <!-- eAdvertiserId           = {{ADVERTISER_ID}} -->
    <!-- eCreativeId             = {{{CREATIVE_ID}} -->
    <!-- ePlacementId            = {{PLACEMENT_ID}} -->
    <!-- eCampaignId             = {{CAMPAIGN_ID}} -->
    <!-- eCampaignName           = {{{CAMPAIGN_NAME}} -->
    <!-- eLineItemId             = {{LINE_ITEM_ID}} -->
    <!-- eAuctionId              = {{AUCTION_ID}} -->
    <!-- eAccountId              = {{ACCOUNT_ID}} -->
    <!-- eAppId                  = {{APP_ID}} -->
    <!-- eUserId                 = {{USER_ID}} -->
    <!-- eClickURL               = {{CLICK_URL}} -->
    <!-- eCreativeSizeW          = {{getWidth}} -->
    <!-- eCreativeSizeH          = {{getHeight}} -->
    <!-- eIFAIOS                 = {{IOS_ID}} -->
    <!-- eIFAAndroid             = {{ANDROID_ID}} -->
    <!-- eGPSLat                 = {{LAT}} -->
    <!-- eGPSLng                 = {{LONG}} -->
    <!-- eBundleId               = {{APP_BUNDLE}} -->
    <!-- eTagId                  = \${TAG_ID} -->

    <!-- eBeeswaxAdvertiserName  = {{ADVERTISER_NAME}} -->
    <!-- eBeeswaxCreativeName    = {{CREATIVE_NAME}} -->
    <!-- eBeeswaxLineItemName    = {{LINE_ITEM_NAME}} -->
    <!-- eBeeswaxAge             = {{AGE}} -->
    <!-- eBeeswaxGender          = {{GENDER}} -->
    <!-- eBeeswaxImpressionURL   = {{IMPRESSION_URL}} -->
    <!-- eBeeswaxHOST            = {{MEDIA_HOST}} -->
    <!-- eBeeswaxPage            = {{PAGE}} -->
    <!-- eBeeswaxDomain          = {{DOMAIN}} -->
    <!-- eBeeswaxReferrer        = {{REFERRER}} -->
    <!-- eBeeswaxInventorySrc    = {{INVENTORY_SOURCE}} -->
    <!-- eBeeswaxExchangeHndl    = {{EXCHANGE_HANDLE}} -->
    <!-- eBeeswaxRewarded        = {REWARDED}} -->
    <!-- eBeeswaxAutoPlayBlck    = {{AUTOPLAY_BLOCKED}} -->
    <!-- eBeeswaxUserAgent       = {{USER_AGENT}} -->
    <!-- eBeeswaxIPAddress       = {{IP_ADDRESS}} -->
    <!-- eBeeswaxIPV6            = {{IP_ADDRESS_IPV6}} -->
    <!-- eBeeswaxDoNotTrack      = {{DNT}} -->
    <!-- eBeeswaxAppName         = {{APP_NAME}} -->
    <!-- eBeeswaxAppStoreUrl     = {{APP_STORE_URL}} -->
    <!-- eBeeswaxDeviceOS        = {{PLATFORM_OS}} -->
    <!-- eBeeswaxDeviceModel     = {{DEVICE_MODEL}} -->
    <!-- eBeeswaxDeviceMake      = {{DEVICE_MAKE}} -->
    <!-- eBeeswaxDeviceType      = {{DEVICE_TYPE}} -->
    <!-- eBeeswaxCarrier         = {{PLATFORM_CARRIER}} -->
    <!-- eBeeswaxIDSHA           = {{USER_ID_SHA1}} -->
    <!-- eBeeswaxBidTimeUTC      = {{BID_TIME_UTC}} -->
    <!-- eBeeswaxCountryCode     = {{COUNTRY_CODE}}} -->
    <!-- eBeeswaxMetroCode       = {{METRO_CODE}} -->
    <!-- eBeeswaxZipCode         = {{ZIP_CODE}} -->
    <!-- eBeeswaxGDPRConst       = {{GDPR_CONSENT_STRING}} -->
    <!-- eBeeswaxIsGDPR          = {{IS_GDPR}} -->
    <!-- eBeeswaxIsGDPRConst     = {{IS_GDPR_CONSENTED}} -->
    <!-- eBeeswaxUSPRIVACY       = {{US_PRIVACY_STRING}} -->
    <!-- eBeeswaxBuzzKey         = {{BUZZ_KEY}} -->
    <!-- eBeeswaxCacheBuster     = {{CACHEBUSTER}} -->
    <!-- eBeeswaxEvtStartUrl     = {{EVENT_START_URL}} -->
    <!-- eBeeswaxEvtQ1Url        = {{EVENT_Q1_URL}} -->
    <!-- eBeeswaxEvtMidUrl       = {{EVENT_MID_URL}} -->
    <!-- eBeeswaxEvtQ3Url        = {{EVENT_Q3_URL}} -->
    <!-- eBeeswaxEvtCompleteUrl  = {{EVENT_COMPLETE_URL}} -->
    <!-- eBeeswaxEvtSkipUrl      = {{EVENT_SKIP_URL}} -->
    <!-- eBeeswaxEvtMuteUrl      = {{EVENT_MUTE_URL}} -->
    <!-- eBeeswaxEvtUnmuteUrl    = {{EVENT_UNMUTE_URL}} -->
    <!-- eBeeswaxEvtPauseUrl     = {{EVENT_PAUSE_URL}} -->
    <!-- eBeeswaxEvtResumeUrl    = {{EVENT_RESUME_URL}} -->
    <!-- eBeeswaxEvtFullscreenUrl = {{EVENT_FULLSCREEN_URL}} -->
    <!-- eBeeswaxEvtCloseUrl     = {{EVENT_CLOSE_URL}} -->
    <!-- eBeeswaxPlayerHeight    = {{PLAYER_HEIGHT}} -->
    <!-- eBeeswaxPlayerWidth     = {{PLAYER_WIDTH}} -->

    {{simpliTagScript}}
</div>`,
        simpli_tag_template_min: '<div class=\'pdsqdx-tag\'><!-- eAdServer = Beeswax DSP --><!-- eTagId = \${TAG_ID} --><!-- eSiteName = {{SITE_NAME}} --><!-- eSiteId = {{SITE_ID}} --><!-- ePublisherId = {{PUBLISHER_ID}} --><!-- eUniversalCreativeID = {{AD-ID}} --><!-- eAdvertiserId = {{ADVERTISER_ID}} --><!-- eCreativeId = {{CREATIVE_ID}} --><!-- ePlacementId = {{PLACEMENT_ID}} --><!-- eCampaignId = {{CAMPAIGN_ID}} --><!-- eCampaignName = {{CAMPAIGN_NAME}} --><!-- eLineItemId = {{LINE_ITEM_ID}} --><!-- eAuctionId = {{AUCTION_ID}} --><!-- eAccountId = {{ACCOUNT_ID}} --><!-- eAppId = {{APP_ID}} --><!-- eUserId = {{USER_ID}} --><!-- eClickURL = {{CLICK_URL}} --><!-- eDestinationUrl = {{CLICK_DESTINATION}} --><!-- eTrackingUrl = {{CLICK_TRACKING_URL}} --><!-- eCreativeSizeW = {{getWidth}} --><!-- eCreativeSizeH = {{getHeight}} --><!-- eIFAIOS = {{IOS_ID}} --><!-- eIFAAndroid = {{ANDROID_ID}} --><!-- eGPSLat = {{LAT}} --><!-- eGPSLng = {{LONG}} --><!-- eBundleId = {{APP_BUNDLE}} --><!-- eBeeswaxAdvertiserName = {{ADVERTISER_NAME}} --><!-- eBeeswaxCreativeName = {{CREATIVE_NAME}} --><!-- eBeeswaxLineItemName = {{LINE_ITEM_NAME}} --><!-- eBeeswaxAge = {{AGE}} --><!-- eBeeswaxGender = {{GENDER}} --><!-- eBeeswaxImpressionURL = {{IMPRESSION_URL}} --><!-- eBeeswaxHOST = {{MEDIA_HOST}} --><!-- eBeeswaxPage = {{PAGE}} --><!-- eBeeswaxDomain = {{DOMAIN}} --><!-- eBeeswaxReferrer = {{REFERRER}} --><!-- eBeeswaxInventorySrc = {{INVENTORY_SOURCE}} --><!-- eBeeswaxExchangeHndl = {{EXCHANGE_HANDLE}} --><!-- eBeeswaxRewarded = {{REWARDED}} --><!-- eBeeswaxAutoPlayBlck = {{AUTOPLAY_BLOCKED}} --><!-- eBeeswaxUserAgent = {{USER_AGENT}} --><!-- eBeeswaxIPAddress = {{IP_ADDRESS}} --><!-- eBeeswaxIPV6 = {{IP_ADDRESS_IPV6}} --><!-- eBeeswaxDoNotTrack = {{DNT}} --><!-- eBeeswaxAppName = {{APP_NAME}} --><!-- eBeeswaxAppStoreURL = {{APP_STORE_URL}} --><!-- eBeeswaxDeviceOS = {{PLATFORM_OS}} --><!-- eBeeswaxDeviceModel = {{DEVICE_MODEL}} --><!-- eBeeswaxDeviceMake = {{DEVICE_MAKE}} --><!-- eBeeswaxDeviceType = {{DEVICE_TYPE}} --><!-- eBeeswaxCarrier = {{PLATFORM_CARRIER}} --><!-- eBeeswaxIDSHA = {{USER_ID_SHA1}} --><!-- eBeeswaxoCuntryCode = {{COUNTRY_CODE}}} --><!-- eBeeswaxBidTimeUTC = {{BID_TIME_UTC}} --><!-- eBeeswaxMetroCode = {{METRO_CODE}} --><!-- eBeeswaxZipCode = {{ZIP_CODE}} --><!-- eBeeswaxGDPRConst = {{GDPR_CONSENT_STRING}} --><!-- eBeeswaxIsGDPR = {{IS_GDPR}} --><!-- eBeeswaxIsGDPRConst = {{IS_GDPR_CONSENTED}} --><!-- eBeeswaxUSPRIVACY = {{US_PRIVACY_STRING}} --><!-- eBeeswaxBuzzKey = {{BUZZ_KEY}} --><!-- eBeeswaxCacheBuster = {{CACHEBUSTER}} --><!-- eBeeswaxEvtStartUrl = {{EVENT_START_URL}} --><!-- eBeeswaxEvtQ1Url = {{EVENT_Q1_URL}} --><!-- eBeeswaxEvtMidUrl = {{EVENT_MID_URL}} --><!-- eBeeswaxEvtQ3Url = {{EVENT_Q3_URL}} --><!-- eBeeswaxEvtCompleteUrl = {{EVENT_COMPLETE_URL}} --><!-- eBeeswaxEvtSkipUrl = {{EVENT_SKIP_URL}} --><!-- eBeeswaxEvtMuteUrl = {{EVENT_MUTE_URL}} --><!-- eBeeswaxEvtUnmuteUrl = {{EVENT_UNMUTE_URL}} --><!-- eBeeswaxEvtPauseUrl = {{EVENT_PAUSE_URL}} --><!-- eBeeswaxEvtResumeUrl = {{EVENT_RESUME_URL}} --><!-- eBeeswaxEvtFullscreenUrl = {{EVENT_FULLSCREEN_URL}} --><!-- eBeeswaxEvtCloseUrl = {{EVENT_CLOSE_URL}} --><!-- eBeeswaxPlayerHeight = {{PLAYER_HEIGHT}} --><!-- eBeeswaxPlayerWidth = {{PLAYER_WIDTH}} --><!-- pdsqdxAdvertiser = {{Advertiser}} --><!-- pdsqdxCampaign = {{CampaignName}} --><!-- pdsqdxPlacement = {{PlacementName}} --><!-- pdsqdxFormat = {{Format}} --><!-- pdsqdxFbkReferenceURL  = {{FallBackUrl}} --><!-- pdsqdx3PID = {{3P_ID}} --> <!-- pdsqdxCID = {{CampaignID}} --><!-- pdsqdxPID = {{PlacementID}} --><!-- pdsqdxECRID = {{ExternalCreativeID}} --><!-- pdsqdxFID = {{FormatID}} -->{{simpliTagScript}}</div>',
    simpli_tag_template_v2_min: '<div class=\'pdsqdx-tag\'{{ps_tag_id}}><!-- eAdServer = Beeswax DSP --><!-- eTagId = \${TAG_ID} --><!-- eSiteName = {{SITE_NAME}} --><!-- eSiteId = {{SITE_ID}} --><!-- ePublisherId = {{PUBLISHER_ID}} --><!-- eUniversalCreativeID = {{AD-ID}} --><!-- eAdvertiserId = {{ADVERTISER_ID}} --><!-- eCreativeId = {{CREATIVE_ID}} --><!-- ePlacementId = {{PLACEMENT_ID}} --><!-- eCampaignId = {{CAMPAIGN_ID}} --><!-- eCampaignName = {{CAMPAIGN_NAME}} --><!-- eLineItemId = {{LINE_ITEM_ID}} --><!-- eAuctionId = {{AUCTION_ID}} --><!-- eAccountId = {{ACCOUNT_ID}} --><!-- eAppId = {{APP_ID}} --><!-- eUserId = {{USER_ID}} --><!-- eClickURL = {{CLICK_URL}} --><!-- eDestinationUrl = {{CLICK_DESTINATION}} --><!-- eTrackingUrl = {{CLICK_TRACKING_URL}} --><!-- eCreativeSizeW = {{getWidth}} --><!-- eCreativeSizeH = {{getHeight}} --><!-- eIFAIOS = {{IOS_ID}} --><!-- eIFAAndroid = {{ANDROID_ID}} --><!-- eGPSLat = {{LAT}} --><!-- eGPSLng = {{LONG}} --><!-- eBundleId = {{APP_BUNDLE}} --><!-- eBeeswaxAdvertiserName = {{ADVERTISER_NAME}} --><!-- eBeeswaxCreativeName = {{CREATIVE_NAME}} --><!-- eBeeswaxLineItemName = {{LINE_ITEM_NAME}} --><!-- eBeeswaxAge = {{AGE}} --><!-- eBeeswaxGender = {{GENDER}} --><!-- eBeeswaxImpressionURL = {{IMPRESSION_URL}} --><!-- eBeeswaxHOST = {{MEDIA_HOST}} --><!-- eBeeswaxPage = {{PAGE}} --><!-- eBeeswaxDomain = {{DOMAIN}} --><!-- eBeeswaxReferrer = {{REFERRER}} --><!-- eBeeswaxInventorySrc = {{INVENTORY_SOURCE}} --><!-- eBeeswaxExchangeHndl = {{EXCHANGE_HANDLE}} --><!-- eBeeswaxRewarded = {{REWARDED}} --><!-- eBeeswaxAutoPlayBlck = {{AUTOPLAY_BLOCKED}} --> <!-- eBeeswaxUserAgent = {{USER_AGENT}} --><!-- eBeeswaxIPAddress = {{IP_ADDRESS}} --><!-- eBeeswaxIPV6 = {{IP_ADDRESS_IPV6}} --><!-- eBeeswaxDoNotTrack = {{DNT}} --><!-- eBeeswaxAppName = {{APP_NAME}} --><!-- eBeeswaxAppStoreURL = {{APP_STORE_URL}} --><!-- eBeeswaxDeviceOS = {{PLATFORM_OS}} --><!-- eBeeswaxDeviceModel = {{DEVICE_MODEL}} --><!-- eBeeswaxDeviceMake = {{DEVICE_MAKE}} --><!-- eBeeswaxDeviceType = {{DEVICE_TYPE}} --><!-- eBeeswaxCarrier = {{PLATFORM_CARRIER}} --><!-- eBeeswaxIDSHA = {{USER_ID_SHA1}} --><!-- eBeeswaxoCuntryCode = {{COUNTRY_CODE}}} --><!-- eBeeswaxBidTimeUTC = {{BID_TIME_UTC}} --><!-- eBeeswaxMetroCode = {{METRO_CODE}} --><!-- eBeeswaxZipCode = {{ZIP_CODE}} --><!-- eBeeswaxGDPRConst = {{GDPR_CONSENT_STRING}} --><!-- eBeeswaxIsGDPR = {{IS_GDPR}} --><!-- eBeeswaxIsGDPRConst = {{IS_GDPR_CONSENTED}} --><!-- eBeeswaxUSPRIVACY = {{US_PRIVACY_STRING}} --><!-- eBeeswaxBuzzKey = {{BUZZ_KEY}} --><!-- eBeeswaxCacheBuster = {{CACHEBUSTER}} --><!-- eBeeswaxEvtStartUrl = {{EVENT_START_URL}} --><!-- eBeeswaxEvtQ1Url = {{EVENT_Q1_URL}} --><!-- eBeeswaxEvtMidUrl = {{EVENT_MID_URL}} --><!-- eBeeswaxEvtQ3Url = {{EVENT_Q3_URL}} --><!-- eBeeswaxEvtCompleteUrl = {{EVENT_COMPLETE_URL}} --><!-- eBeeswaxEvtSkipUrl = {{EVENT_SKIP_URL}} --><!-- eBeeswaxEvtMuteUrl = {{EVENT_MUTE_URL}} --><!-- eBeeswaxEvtUnmuteUrl = {{EVENT_UNMUTE_URL}} --><!-- eBeeswaxEvtPauseUrl = {{EVENT_PAUSE_URL}} --><!-- eBeeswaxEvtResumeUrl = {{EVENT_RESUME_URL}} --><!-- eBeeswaxEvtFullscreenUrl = {{EVENT_FULLSCREEN_URL}} --><!-- eBeeswaxEvtCloseUrl = {{EVENT_CLOSE_URL}} --><!-- eBeeswaxPlayerHeight = {{PLAYER_HEIGHT}} --><!-- eBeeswaxPlayerWidth = {{PLAYER_WIDTH}} -->{{simpliTagScript}}</div>'
      }
      ]
    },
    CREATE: (state, payload) => {

    },
    UPDATE: (state, payload) => {

    },
    DELETE: (state, payload) => {

    },
    SET_TAGS: (state, generated_tags) => {
      state.placements.map(placement => {
        placement.tag = generated_tags[placement.id]
      })
    },
    SET_ADSERVER: (state, adserver_id) => {
      state.adserver_id = adserver_id
    },
    SET_TAG_VERSION: (state, payload) => {
      state.tag_version_id = payload
    },
    SET_CREATIVE_SIZE: (state, payload) => {
      state.creative_size_selected = payload
      // console.log('SET creative size', state.creative_size_selected);
    },
    SET_CREATIVESIZE_CHECKED: (state, payload) => {
      state.creative_size_checked = payload
    },
    SET_CREATIVES: (state, payload) => {
      state.creatives = payload
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetch: ({
      dispatch,
      commit
    }, data) => {
      // app status loading
      dispatch('registerTask', 'fetchTags', {
        root: true
      })

      return new Promise((resolve, reject) => {
        ApiTagManager.getTags(data)
          .then(result => {
            return result.data
          })
          .then(data => commit('SET', data))
          .then(data => {
            dispatch('completeTask', 'fetchTags', {
              root: true
            })
            resolve(data)
          })
          .catch(error => {
            dispatch('completeTask', 'fetchTags', {
              root: true
            })
            reject(error)
          })
      })
    },
    setTagsByAdServer: ({
      commit
    }, adserver_id) => {
      commit('SET_ADSERVER', adserver_id)
    },
    setTagVersion: ({
      commit
    }, tag_version_id) => {
      commit('SET_TAG_VERSION', tag_version_id)
    },
    setCreativeSize: ({ commit, state }, size) => {
      commit('SET_CREATIVE_SIZE', size)
    },
    setCreativeSizeChecked: ({ commit, state }, checked) => {
      commit('SET_CREATIVESIZE_CHECKED', checked)
    },
    setCreatives: ({ commit, state }, creatives) => {
      commit('SET_CREATIVES', creatives)
    }
  }
}
